import React, { Component } from 'react';
import {
    Card,
    CardTitle,
    TextField,
    Button
} from 'react-md';

import Api from '../../common/api';
import { login } from '../../common/auth';
import { isValidEmail, isValidPassword } from '../../common/checkers';
import { formatCpf } from '../../common/formaters';
import Message from '../../components/message';
import { openSnackbar } from '../../components/message';
import logo from '../../assets/img/logo.png';
import { clearDigitsSpecialChars } from '../../common/parsers';

export default class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cpf: "",
            senha: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {

        const {cpf, senha} = this.state;
        return (
            <div className="md-grid login-container">
                <div className="login-title" >
                    <img src={logo} alt="Logo"/>
                    <h3>GESTÃO DE PEDIDOS</h3>
                </div>
                <Card className="tw-card">
                    <CardTitle title="Login" />
                    <form className="md-grid" onSubmit={this.handleSubmit}>
                        <TextField id="cpf" label="CPF" type="text" placeholder="Digite seu CPF" value={cpf}
                            className="md-cell md-cell--12" onChange={this.handleChangeCpf}/>

                        <TextField id="senha" label="Senha" type="password" placeholder="Digite sua Senha" value={senha}
                             className="md-cell md-cell--12" onChange={this.handleChange('senha')}/>

                        <Button type="submit" raised primary className="md-cell md-cell--12">Entrar</Button>
                    </form>
                </Card>
                <Message />
            </div>
        );
    }

    handleChange = name => value => {
        this.setState({ [name]: value });
    }

    handleChangeCpf = value => {
        this.setState({ cpf:  formatCpf(value)});
    }

    validateForm() {
        return isValidEmail(this.state.cpf) && isValidPassword(this.state.senha)
    }

    handleSubmit = event => {
        event.preventDefault();
        try {
            Api.login(clearDigitsSpecialChars(this.state.cpf), this.state.senha)
            .then(response => {
                switch (response.status) {
                    case 200:
                        response.json()
                            .then(data => {
                                login(data)
                                this.props.history.push('/clientes')
                            })
                        break
                    default:
                        openSnackbar({ message: 'Dados de acesso não conferem' });
                }
            }).catch(error => {
                localStorage.removeItem('accessToken')
            });
        } catch (e) {
            openSnackbar({ message: e })
           return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/login/Login.js